import type { Components, Theme } from '@mui/material'

const dialogTitle: Components<Omit<Theme, 'components'>>['MuiDialogTitle'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: theme.palette.primary.main,
      padding: theme.spacing(2),
    }),
  },
}

export default dialogTitle
